import { writable } from 'svelte/store';
export const savedBlobs = new Map();
export const showAudioDownloadIndicator = writable('');
